"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageReceiverHelpers = void 0;
var TeamChannelReceiver_1 = require("./TeamChannelReceiver");
var MessageReceiverHelpers = (function () {
    function MessageReceiverHelpers() {
    }
    MessageReceiverHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof TeamChannelReceiver_1.TeamChannelReceiver;
    };
    MessageReceiverHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    MessageReceiverHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'TeamChannelReceiver': return new TeamChannelReceiver_1.TeamChannelReceiver(content);
            default:
                throw new Error('Unknown type id ' + id + ' for MessageReceiver');
        }
    };
    return MessageReceiverHelpers;
}());
exports.MessageReceiverHelpers = MessageReceiverHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.services.teams.MessageReceiver', {
    full: 'net.playq.services.teams.MessageReceiver',
    short: 'MessageReceiver',
    package: 'net.playq.services.teams',
    type: irt_1.IntrospectorTypes.Adt,
    options: [
        {
            name: 'TeamChannelReceiver',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.teams.TeamChannelReceiver' }
        }
    ]
});
//# sourceMappingURL=MessageReceiver.js.map